/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1BannerBanneridLangsId200,
  GetApiV1BannerBanneridLangsId401,
  GetApiV1BannerBanneridLangsId404,
  GetApiV1BannerBanneridLangsId500,
  GetApiV1BannerBanneridLangsIdPathParams,
  GetApiV1BannerBanneridLangsIdQueryResponse,
} from "../../types/bannerIdiomasController/GetApiV1BannerBanneridLangsId.ts";
import { bannerLangViewModelSchema } from "../bannerLangViewModelSchema.ts";

export const getApiV1BannerBanneridLangsIdPathParamsSchema = z.object({
  bannerId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1BannerBanneridLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1BannerBanneridLangsId200Schema = z.lazy(
  () => bannerLangViewModelSchema,
) as unknown as ToZod<GetApiV1BannerBanneridLangsId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1BannerBanneridLangsId401Schema =
  z.any() as unknown as ToZod<GetApiV1BannerBanneridLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1BannerBanneridLangsId404Schema =
  z.any() as unknown as ToZod<GetApiV1BannerBanneridLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1BannerBanneridLangsId500Schema =
  z.any() as unknown as ToZod<GetApiV1BannerBanneridLangsId500>;

export const getApiV1BannerBanneridLangsIdQueryResponseSchema = z.lazy(
  () => getApiV1BannerBanneridLangsId200Schema,
) as unknown as ToZod<GetApiV1BannerBanneridLangsIdQueryResponse>;
